
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useRfmFrequency } from '@/modules/rfm/frequency/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.FREQUENCY.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, fetch, rfmGroupOptions, fetchRfmGroupAll, actions } = useRfmFrequency();

        onMounted(async () => {
            await fetchRfmGroupAll();
            await fetch();
        });

        return { v$, model, rfmGroupOptions, actions };
    }
});
